import { useEffect, useRef } from 'react';
import { registerDraftProvider, takeDraft } from '../utils/sessionRestore';

/**
 * Publishes a screen's in-progress data so an inactivity sign-out can hand it
 * back after the same user signs in again.
 *
 * @param {string} key      stable id for this screen's draft
 * @param {*} value         current draft; return undefined to save nothing
 * @param {(saved:*) => void} onRestore applied once, on mount, if a draft is waiting
 */
export default function useSessionDraft(key, value, onRestore) {
  const valueRef = useRef(value);
  valueRef.current = value;

  const restoreRef = useRef(onRestore);
  restoreRef.current = onRestore;

  useEffect(() => registerDraftProvider(key, () => valueRef.current), [key]);

  useEffect(() => {
    const saved = takeDraft(key);
    if (saved !== undefined) restoreRef.current?.(saved);
  }, [key]);
}
